import React from 'react';

import ErrorMessage from '../../error_message/ErrorMessage';
import { formatPrice } from '../../../../utils';

const PaymentDeadline = (props) => {
  const selectParcel = (i) => {
    props.selectPaymentCreditCard(3);
    props.selectCreditCardParcel(i);
  };

  if (!props.parcels) return null;

  if (props.type === 'mobile')
    return (
      <div className="list-parcelas-mobile" style={{ display: props.stepDisplayCreditCard !== 2 ? 'none' : 'block' }}>
        <h4>Opções de parcelamento</h4>
        <ul>
          {props.parcels.map((parcels, i) => (
            <label htmlFor={'radio' + i} key={i}>
              <li className={`${parcels.selected && 'checked'}`}>
                <strong>
                  {parcels.times} {parcels.times > 1 ? 'parcelas' : 'parcela'}{' '}
                </strong>{' '}
                <span>
                  {parcels.times}x de R$ {formatPrice(parcels.price)}
                </span>
                <input
                  type="radio"
                  index={i}
                  checked={parcels.selected}
                  id={'radio' + i}
                  name="parcela"
                  onChange={(_) => selectParcel(i)}
                  onClick={(_) => selectParcel(i)}
                />
              </li>
            </label>
          ))}
        </ul>

        <ErrorMessage anchor={`creditCard_parcels`} field1="creditCard" field2={'parcels'} />
      </div>
    );

  const halfwayIndex = Math.ceil(props.parcels.length / 2);

  return (
    <div className="flex parcelamento-desktop">
      <h4>Selecione a quantidade de parcelas</h4>
      <ul className="list-parcelas">
        {props.parcels.map((parcels, i) => (
          <li
            className={`${parcels.selected && 'checked'} item ${i >= halfwayIndex ? 'second-half' : ''}`}
            key={i}
            onClick={(_) => props.selectCreditCardParcel(i)}
          >
            <label htmlFor={'radio' + i} className="label-form">
              <input
                type="radio"
                index={i}
                checked={parcels.selected ? true : false}
                id={'radio' + i}
                name="parcela"
                onChange={(_) => props.selectCreditCardParcel(i)}
              />
              {parcels.times}x R$ {formatPrice(parcels.price)}
            </label>
          </li>
        ))}
      </ul>
       <div style={{ marginTop: '20px' }}>
          <ErrorMessage anchor={`creditCard_parcels`} field1="creditCard" field2={'parcels'} style={{ marginTop: 'unset', marginBottom: 'unset' }} />
        </div>
    </div>
  );
};

export default PaymentDeadline;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard/PaymentDeadline.jsx